import React, { useEffect, useState } from "react";

const overlayStyle = {
  position: "fixed",
  inset: 0,
  background: "rgba(0,0,0,0.6)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  zIndex: 2147483646,
  padding: "2rem",

  overflowY: "auto",           // ✅ ADD
  // WebkitOverflowScrolling: "touch", // ✅ KEEP
};


const modalBase = {
  background: "#fff",
  borderRadius: 12,
  width: "100%",
  maxWidth: 480,
  boxShadow: "0 10px 30px rgba(0,0,0,0.2)",
  position: "relative",
  padding: "18px 20px",
};

const closeBtnStyle = {
  position: "absolute",
  top: 10,
  right: 12,
  background: "transparent",
  border: "none",
  fontSize: 20,
  cursor: "pointer",
  lineHeight: 1,
};

const inputStyle = {
  width: "100%",
  padding: "10px 12px",
  marginBottom: 6,
  borderRadius: 8,
  border: "1px solid #ddd",
  fontSize: 14,
  boxSizing: "border-box",
};

const errorStyle = {
  color: "#d32f2f",
  fontSize: 12,
  marginBottom: 10,
};

const submitStyle = {
  width: "100%",
  background: "#683FEA",
  color: "#fff",
  padding: "10px 12px",
  borderRadius: 8,
  border: "none",
  fontSize: 16,
  cursor: "pointer",
};

export default function DemoFormModal({ language = "en", onClose }) {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });

  const [errors, setErrors] = useState({});

  const dir = language === "ar" ? "rtl" : "ltr";

  const validationText =
    language === "ar"
      ? {
          required: "هذا الحقل مطلوب",
          email: "يرجى إدخال بريد إلكتروني صحيح",
        }
      : {
          required: "This field is required",
          email: "Please enter a valid email",
        };

  useEffect(() => {
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = prev;
    };
  }, []);

  const handleChange = (e) => {
    setFormData((s) => ({ ...s, [e.target.name]: e.target.value }));
    setErrors((s) => ({ ...s, [e.target.name]: "" }));
  };

  const validate = () => {
    const newErrors = {};

    if (!formData.name.trim()) newErrors.name = validationText.required;
    if (!formData.phone.trim()) newErrors.phone = validationText.required;
    if (!formData.message.trim()) newErrors.message = validationText.required;

    if (!formData.email.trim()) {
      newErrors.email = validationText.required;
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = validationText.email;
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    await fetch(
      "https://script.google.com/macros/s/AKfycbx8ZkaIJBIZMvb7PQfSoBUQz57VPqxuORvy1qNvlj8_CvAUEPTzI3BwnE0jfDTroFIV/exec",
      {
        method: "POST",
        mode: "no-cors",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      }
    );

    onClose?.();
  };

  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && onClose?.();
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose]);

  return (
    <div style={overlayStyle} onClick={onClose} dir={dir}>
      <div
        style={{ ...modalBase, direction: dir }}
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onClick={onClose}
          style={{
            ...closeBtnStyle,
            right: dir === "ltr" ? 12 : "auto",
            left: dir === "rtl" ? 12 : "auto",
          }}
        >
          ✕
        </button>

        <h3 style={{ marginBottom: 12 }}>
          {language === "ar" ? "احجز العرض التجريبي المجاني" : "Book Your Free Demo"}
        </h3>

        <form onSubmit={handleSubmit}>
          <input
            name="name"
            value={formData.name}
            onChange={handleChange}
            placeholder={language === "ar" ? "الاسم الكامل" : "Full name"}
            style={inputStyle}
          />
          {errors.name && <div style={errorStyle}>{errors.name}</div>}

          <input
            name="email"
            value={formData.email}
            onChange={handleChange}
            placeholder={language === "ar" ? "البريد الإلكتروني" : "Email"}
            style={inputStyle}
          />
          {errors.email && <div style={errorStyle}>{errors.email}</div>}

          <input
            name="phone"
            value={formData.phone}
            onChange={handleChange}
            placeholder={language === "ar" ? "رقم الهاتف" : "Phone"}
            style={inputStyle}
          />
          {errors.phone && <div style={errorStyle}>{errors.phone}</div>}

          <textarea
            name="message"
            value={formData.message}
            onChange={handleChange}
            placeholder={language === "ar" ? "رسالتك" : "Your message"}
            rows={4}
            style={{ ...inputStyle, resize: "vertical" }}
          />
          {errors.message && <div style={errorStyle}>{errors.message}</div>}

          <button type="submit" style={submitStyle}>
            {language === "ar" ? "إرسال" : "Submit"}
          </button>
        </form>
      </div>
    </div>
  );
}
